'use client';

import type { ReactNode } from 'react';
import { useCartStore } from 'stores/cart';

interface ArticleCardVisibilityProps {
  articleId: number;
  children: ReactNode;
}

export function ArticleCardVisibility({ articleId, children }: ArticleCardVisibilityProps) {
  const deletedArticleIds = useCartStore(s => s.deletedArticleIds);
  if (deletedArticleIds.includes(articleId)) return null;

  return <>{children}</>;
}
